import {
  ScopeOfPracticeEnum,
  ShiftStatusEnum,
  ShiftTypeEnum
} from '@umss/shared/utils';

export interface ShiftSearchDto {
  facilityId?: string;
  contractorId?: string;
  corporateId?: string;
  facilityIds?: string[];
  scopesOfPractice?: ScopeOfPracticeEnum[];
  statuses?: (ShiftStatusEnum | `${ShiftStatusEnum}`)[];
  shiftTypes?: (ShiftTypeEnum | `${ShiftTypeEnum}`)[]; // Backend now accepts text values (e.g., 'Urgent', 'Regular')
  scopeOfPractice?: ScopeOfPracticeEnum;
  startDate?: string;
  endDate?: string;
  minHourlyRate?: number;
  maxHourlyRate?: number;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string;
  sortDescending?: boolean;
}
